import { ReactNode } from 'react';

import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';
import { isColor } from '~/src/common/utils/guards';

interface Props {
  className?: string;
  bgColor?: string;
  fgColor?: string;
  children: ReactNode;
}

const Base = styled.div`
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  line-height: 24px;
  padding: 0 4px;
  white-space: pre;
  width: fit-content;
`;

export const Tag = ({
  className,
  fgColor = 'NEUTRAL_DEFAULT',
  bgColor = 'GROUND_UNDERGROUNDLIGHT',
  children,
}: Props) => (
  <Base
    className={className}
    style={{
      color: isColor(fgColor) ? COLORS[fgColor] : fgColor,
      backgroundColor: isColor(bgColor) ? COLORS[bgColor] : bgColor,
    }}>
    {children}
  </Base>
);
